import React, { useState } from "react";
import "./Login.css";

const Login = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch("/backend/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ password }),
        credentials: "include", // Permite el uso de cookies en la petición
      });

      const data = await response.json();

      if (data.success) {
        const expires = new Date();
        expires.setDate(expires.getDate() + 1); // Cookie válida por 1 día

        document.cookie = `authenticated=true; path=/; expires=${expires.toUTCString()}; Secure; SameSite=Lax`;
        onLoginSuccess(); // Autenticar al usuario
      } else {
        setError("Contraseña incorrecta");
      }
    } catch (error) {
      console.error("Error en la autenticación:", error);
      setError("Error al intentar iniciar sesión");
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-box">
        <h2>Acceder a la galería</h2>
        <input
          type="password"
          placeholder="Introduce la contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />
        <button type="submit">Entrar</button>
        {error && <p className="error">{error}</p>}
      </form>
    </div>
  );
};

export default Login;
